


















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'dn-loader',
})
export default class Loader extends Vue {
  @Prop({ type: Boolean, default: false }) isNested!: boolean;
}
